import styled from 'styled-components';

export const TalentAttractionPage = styled.main.attrs({ className: 'TalentAttraction' })`
  --ta-neutral-0: ${({ theme }) => theme.colors?.neutral?.[0]};
  --ta-neutral-20: ${({ theme }) => theme.colors?.neutral?.[20]};
  --ta-neutral-50: ${({ theme }) => theme.colors?.neutral?.[50]};
  --ta-neutral-100: ${({ theme }) => theme.colors?.neutral?.[100]};
  --ta-neutral-300: ${({ theme }) => theme.colors?.neutral?.[300]};
  --ta-neutral-400: ${({ theme }) => theme.colors?.neutral?.[400]};
  --ta-neutral-500: ${({ theme }) => theme.colors?.neutral?.[500]};
  --ta-neutral-700: ${({ theme }) => theme.colors?.neutral?.[700]};
  --ta-neutral-900: ${({ theme }) => theme.colors?.neutral?.[900]};
  --ta-text-subtle: ${({ theme }) => theme.colors?.text?.subtle};
  --ta-text-main: ${({ theme }) => theme.colors?.text?.main};
  --ta-text-dark: ${({ theme }) => theme.colors?.text?.dark};
  --ta-purple-100: ${({ theme }) => theme.colors?.purple?.[100]};
  --ta-purple-500: ${({ theme }) => theme.colors?.purple?.[500]};
  --ta-green-600: ${({ theme }) => theme.colors?.green?.[600]};
  --ta-green-700: ${({ theme }) => theme.colors?.green?.[700]};
  --ta-orange-600: ${({ theme }) => theme.colors?.orange?.[600]};
`;
